import { SimonFields as SimonFields$1 } from '@zillow/zrs-cms';
import PropTypes from 'prop-types';
import React from 'react';
import { generateBlockList } from '../../components/BlockList/BlockList.js';
import makeContentInteractive from '../../util/makeSpansInteractive.js';

var BlockSimonFields = function BlockSimonFields(_ref) {
  var attrs = _ref.attrs,
    index = _ref.index,
    innerBlocks = _ref.innerBlocks;
  var buttonText = attrs.buttonText,
    _attrs$legalText = attrs.legalText,
    legalText = _attrs$legalText === void 0 ? 'By submitting this form, you agree to receive email communication from Zillow. We respect your privacy. See our <a target="_blank" href="https://www.zillow.com/corp/Privacy.htm">privacy policy</a>.' : _attrs$legalText;
  return /*#__PURE__*/React.createElement(SimonFields$1, {
    key: index,
    buttonText: buttonText,
    legalText: makeContentInteractive(legalText)
  }, generateBlockList({
    blocks: innerBlocks
  }));
};
BlockSimonFields.propTypes = process.env.NODE_ENV !== "production" ? {
  index: PropTypes.number,
  attrs: PropTypes.shape({})
} : {};
var SimonFields = BlockSimonFields;

export { SimonFields as default };
